module.exports = __webpack_public_path__ + "img/candy-corn.0e053a24.svg";